export const categoryData = [
  { id: "custom", name: "Покупці" },
  { id: "provider", name: "Постачальники" },
];
